import { render, staticRenderFns } from "./ExtratoItem.vue?vue&type=template&id=d070e4b6"
import script from "./ExtratoItem.vue?vue&type=script&lang=js"
export * from "./ExtratoItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports